import type { FieldErrors } from "react-hook-form";

export const isFormInvalid = (err: FieldErrors) => {
  return Object.keys(err).length > 0;
};
